import { useState } from 'react'

import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSButton from 'designSystem/components/PDSButton/PDSButton'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSSubCard from 'designSystem/components/PDSSubCard/PDSSubCard'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { SIZE } from 'designSystem/foundations/constants/size'

import AssetETFMutualFundMappingModal from './AssetETFMutualFundMappingModal'

export default function AssetETFMutualFundMappingSection() {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <PDSSubCard backgroundColor="none">
        <PDSFlexBox
          alignItems="center"
          justifyContent="space-between"
          gap={SIZE.s72}
        >
          <PDSBox maxWidth="60rem">
            <PDSText>
              <b>Note:</b> We use a proprietary model designed to optimize
              client portfolios based on factors such as cost efficiency, asset
              class exposure, tax treatment, and risk-adjusted returns.
            </PDSText>
          </PDSBox>

          <PDSButton
            text="Learn More"
            onClick={() => setShowModal(true)}
            variant="tertiary"
          />
        </PDSFlexBox>
      </PDSSubCard>
      <AssetETFMutualFundMappingModal
        onClose={() => setShowModal(false)}
        showModal={showModal}
      />
    </>
  )
}
